export class AccountGroup {
  accountGroupId: string;
  partnerId: string;
  companyName: string;
  marketId: string;
  suspended: boolean;
  latitude: number;
  longitude: number;
  address: string;
  address2?: string;
  country: string;
  state: string;
  city: string;
  taxIds: string[];
  zip: string;
  website: string;
  workNumber?: string[];
  serviceAreaBusiness?: boolean;
  hasRepMan?: boolean;
  isRepManExpired?: boolean;
  repManEditionID?: string;
  hasTaskManager?: boolean;
  email?: string;
  vCategoryIds?: string[];

  constructor(data?: Partial<AccountGroup>) {
    Object.assign(this, data);
  }

  get title(): string {
    return this.companyName;
  }

  get subtitle(): string {
    return getLocation(this);
  }
}

export function getLocation(accountGroup: AccountGroup): string {
  let location = '';
  if (accountGroup && (accountGroup.address || accountGroup.city || accountGroup.state)) {
    const locationItems = [accountGroup.address, accountGroup.address2, accountGroup.city, accountGroup.state];
    location = locationItems.filter((i) => !!i).join(', ');
  }
  return location;
}

export function fullAddress(accountGroup: AccountGroup): string {
  return [accountGroup.address, accountGroup.address2, accountGroup.city, accountGroup.state, accountGroup.country]
    .filter((p) => !!p)
    .join(', ');
}
